module.exports = __webpack_public_path__ + "static/media/background.828f774b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biocodex-um/background.jpg
// module id = 644
// module chunks = 1